import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/pro-regular-svg-icons/faHeadset";

export const defaultTranslations = {
    pluginName: "Support Panels",
    pluginDescription: "Add support panels",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faHeadset} size="3x" />,
};
